<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins" style="margin-bottom:30px;">
          <promotionList></promotionList>
        </div>
        <div class="ibox float-e-margins">
          <confirmedList></confirmedList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "../config";
import promotionList from "@/components/schoolEventListing/promotionList"
import confirmedList from "@/components/schoolEventListing/confirmedList"

export default {
  mixins: [config.globalMixin],
  components: {promotionList,confirmedList},
  data() {
    return {

    };
  },
  computed: {

  },
  created() {},
  mounted() {
  },
  methods: {

  },
};
</script>
